/**
 * @generated SignedSource<<3f2badd0490a9633bb09bca889770123>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type LearnableKind = "Course";
import { FragmentRefs } from "relay-runtime";
export type offersTable_UnpublishedLearnableFragment$data = {
  readonly id: string;
  readonly kind: LearnableKind;
  readonly root?: {
    readonly hasBeenPublishedOnce: boolean;
    readonly id: string;
    readonly structureDefinition: {
      readonly title: string;
    };
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"deleteCourseLearnableButton_UnpublishedLearnableFragment" | "editCourseLearnableButton_UnpublishedLearnableFragment">;
  readonly " $fragmentType": "offersTable_UnpublishedLearnableFragment";
};
export type offersTable_UnpublishedLearnableFragment$key = {
  readonly " $data"?: offersTable_UnpublishedLearnableFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"offersTable_UnpublishedLearnableFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "offersTable_UnpublishedLearnableFragment"
};

(node as any).hash = "0e42a18db60d22a6e8e2cfe9967b1c0e";

export default node;
